import { PaginatedResponse } from "./paginated-response";

export class MarketOrderSummary extends PaginatedResponse{
    records: MarketOrder[] = [];
}

export class MarketOrder {
    worksheetId: string;
    worksheetName: string;
    projectId: string;
    projectName: string;
    initiatorId: string;
    initiatorName: string;
    initiatorTeamId: string;
    initiatorTeamName: string;
    approverId: string;
    approverName: string;
    lastModifiedDate: Date;
    status: string;
    notes: string;
    subtotal: number;
    quoted: boolean;
    orderNumber: string;
    dateQuoted: Date;
    dateOrdered: Date;
    marketOrderDetails: MarketOrderDetail[] = [];

    //Used in UI
    checked: boolean = false;

    constructor(data: any = {}) {
        this.worksheetId = data.worksheetId;
        this.worksheetName = data.worksheetName;
        this.projectId = data.projectId;
        this.projectName = data.projectName;
        this.initiatorId = data.initiatorId;
        this.initiatorName = data.initiatorName;
        this.initiatorTeamId = data.initiatorTeamId;
        this.initiatorTeamName = data.initiatorTeamName;
        this.approverId = data.approverId;
        this.approverName = data.approverName;
        this.lastModifiedDate = data.lastModifiedDate || new Date();
        this.status = data.status;
        this.notes = data.notes;
        this.subtotal = data.subtotal;
        this.quoted = data.quoted;
        this.orderNumber = data.orderNumber;
        this.dateQuoted = data.dateQuoted;
        this.dateOrdered = data.dateOrdered;
        this.marketOrderDetails = data.marketOrderDetails;
    }
}

export class MarketOrderDetail {
    bomlineId: string;
    sku: string;
    partNumber: string;
    description: string;
    qtyOrdered: string;

    constructor(data: any = {}) {
        this.bomlineId = data.bomlineId;
        this.sku = data.sku;
        this.partNumber = data.partNumber;
        this.description = data.description;
        this.qtyOrdered = data.qtyOrdered;
    }
}

export class MarketOrderInput {
    marketId: string;
    initiatorId: string;
    approverId: string;
    status: string;
    searchText: string;

    constructor(marketId: string, initiatorId?: string, approverId?: string, status?: string, searchText?: string) {
        this.marketId = marketId;
        this.initiatorId = initiatorId;
        this.approverId = approverId;
        this.status = status;
        this.searchText = searchText;
    }

}

export class MarketOrderSavedFilter {
    id: string;
    userId: string;
    mosWorksheetStatus: string;
    mosWorksheetStatusValue: string;
    mosWorksheetOwnerId: string;
    mosWorksheetOwnerName: string;
    mosApproverId: string;
    mosApproverName: string;
    marketId: string;
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/market-order-summary.ts